import { api } from "../../../lib/api";



/** Résout une URL média organisation (logo, photo) en URL absolue pour le navigateur. */
export const resolveOrganizationMediaUrl = (input?: string | null): string | undefined => {
  if (!input) return undefined;
  if (input.startsWith("data:image/")) return input;

  const base = String(api.defaults.baseURL ?? "/api");
  const apiUrl = new URL(base, window.location.origin);
  const apiPrefix = apiUrl.pathname.replace(/\/+$/, "");

  if (input.startsWith("/organizations/media/")) {
    return `${apiUrl.origin}${apiPrefix}${input}`;
  }
  if (input.startsWith("/api/organizations/media/")) {
    return `${apiUrl.origin}${input}`;
  }
  if (input.startsWith("/")) {
    return input;
  }

  try {
    const parsed = new URL(input);
    if (parsed.pathname.startsWith("/organizations/media/")) {
      return `${apiUrl.origin}${apiPrefix}${parsed.pathname}${parsed.search}`;
    }
    if (parsed.pathname.startsWith("/api/organizations/media/")) {
      return `${apiUrl.origin}${parsed.pathname}${parsed.search}`;
    }
    return input;
  } catch {
    return input;
  }
}
